import CRUDService from 'src/services/CRUDService';

export interface EndpointConfiguration {
  url: string;
  authenticationMethod: string;
  username: string;
  password: string;
  id: string;
}

export default new CRUDService<EndpointConfiguration>({
  baseUrl: '/v1/endpoint-configurations',
  useJWT: true,
});
